import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=db8dbb0a&scoped=true"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"
import style0 from "./detail.vue?vue&type=style&index=0&id=db8dbb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8dbb0a",
  null
  
)

export default component.exports